import { BrowserRouter, Routes, Route } from "react-router-dom";
import RegisterPage from "./pages/register";
import LoginPage from "./pages/login";
import HomePage from "./pages/home";
import "./App.css";
import { Layout } from "./app/layout";
import { SnackbarProvider, closeSnackbar } from "notistack";
import { CloseButton } from "react-bootstrap";
import ForgotPage from "./pages/forgot";
import ProfilePage from "./pages/profile";

export default function App() {
  return (
    <SnackbarProvider
      className="snackbar-styles"
      action={(key) => (
        <CloseButton
          className="snackbar-button-close"
          onClick={() => closeSnackbar(key)}
        ></CloseButton>
      )}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={4000}
      maxSnack={4}
    >
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            {/* <Route path="/chat" element={<PrivateRoute><ChatPage /></PrivateRoute>} /> */}
            <Route path="/forgot" element={<ForgotPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </SnackbarProvider>
  );
}
